<mat-form-field>
  <mat-label>{{ 'tourDetails.manager' | translate }}</mat-label>
  <input
    type="text"
    placeholder="{{ 'tourDetails.manager' | translate }}"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
  >
  <mat-error *ngIf="control.invalid">
    {{ 'tourDetails.error.manager' | translate }}
  </mat-error>
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    [displayWith]="displayUser"
    >
    @if ((actionPending$ | async)) {
      <mat-option class="is-loading">
        <mat-spinner diameter="30"></mat-spinner>
      </mat-option>
    }
    @if (false === (actionPending$ | async)) {
      @for (user of filteredUsers$ | async; track user) {
        <mat-option [value]="user">
          {{ user.firstName }} {{ user.lastName }}
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
